import BaseGameFactory from "../../core/src/factories/BaseGameFactory";
import BaseSettings from "../../core/src/ui/BaseSettings";
import UIDesktopView from "../base/ui/UIDesktop";
import BaseUI from "../../core/src/ui/BaseUI";
import AutoplayPage from "../base/ui/AutoplayPage";

import InfoBar from '../base/ui/InfoBar';
import PageSettings from '../../core/src/ui/settings/PageSettings';


export class GameFactory extends BaseGameFactory {
    protected getSettings(): BaseSettings {
        return new PageSettings();
    }

    protected getAutoplayPage(): BaseUI {
        return new AutoplayPage();
    }

    protected getUIView(): BaseUI {
        return new UIDesktopView();
    }

    protected getInfoBar(): BaseUI {
        return new InfoBar();
    }


}

export default GameFactory;
